module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'filterForm',
    ],
}